import type { ElementTweenFunction } from '../types';
import { gsap } from 'gsap';

/**
 * Premade tween: Fades in the target element from opacity 0.
 * Can be added to an elementsTimeline at a specific position.
 * @param target - The element to animate.
 * @param options - Customization options.
 * @param elementsTimeline - Optional timeline to add this tween to.
 * @param position - Optional insertion point in the elementsTimeline.
 * @returns A GSAP tween instance or void if added to a timeline.
 */
export const fadeIn: ElementTweenFunction = ({
    target,
    options,
    elementsTimeline,
    position,
    direction,
    duration: propDuration // Allow duration override via props
}) => {
    if (direction === "back") return { tween: undefined, position: "0" }

    const duration = propDuration ?? options?.duration ?? 1.5; // Use propDuration > options.duration > default
    const ease = options?.ease ?? 'power1.out';
    const tween = gsap.fromTo(target, { autoAlpha: 0 }, {
        autoAlpha: 1, duration, ease, ...options // Spread remaining options
    });
    if (elementsTimeline) {
        elementsTimeline.add(tween, position);
        return { tween: undefined, position: "<60%" }
    }

    return { tween, position: "<" }; // Return the tween if not added to a timeline
};
